var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    viewBox: "0 0 52.32 87.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3 79.16H2.02C.9 79.16 0 79.95 0 80.91v4.57c0 .97.91 1.75 2.02 1.75h48.27c1.12 0 2.02-.79 2.02-1.75v-4.57c0-.97-.91-1.75-2.02-1.75ZM43.21 60.91h-5.95c-7.45 0-7.12-6.24-7.12-9.5V26.9h12.1c.65 0 1.19-.21 1.61-.63.42-.42.63-.96.63-1.61v-3.87c0-.65-.21-1.19-.63-1.61-.42-.42-.96-.63-1.61-.63h-12.1V2.24c0-.65-.21-1.19-.63-1.61C29.09.21 28.55 0 27.9 0h-4.59c-.65 0-1.19.21-1.61.63-.42.42-.63.96-.63 1.61v16.29H9.11c-.65 0-1.19.21-1.61.63-.42.42-.63.96-.63 1.61v3.87c0 .65.21 1.19.63 1.61.42.42.96.63 1.61.63h11.96v25.2c-.11 13.57 5.14 17.17 15.41 17.17h6.73c.65 0 1.19-.21 1.61-.63.42-.42.63-.96.63-1.61v-3.87c0-.65-.21-1.19-.63-1.61-.42-.42-.96-.63-1.61-.63Z",
    className: "cls-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMarkWhite);
export default __webpack_public_path__ + "static/media/logo-mark-white.b92b6e90968b5207c446c0098b09c52c.svg";
export { ForwardRef as ReactComponent };